import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVisionPro: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVisionPro"><Path d="M12 15.25C9.38636 15.25 9.38636 18.5 5.72727 18.5C2.06818 18.5 0.5 15.25 0.5 12C0.5 6.04167 6.77273 5.49998 12 5.5C17.2273 5.50002 23.5 6.04167 23.5 12C23.5 15.1801 21.9318 18.5 18.2727 18.5C14.6136 18.5 14.6136 15.25 12 15.25Z" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconVisionPro;
